import Cookies from 'universal-cookie';

/** Cookie holding the JWT access token. */
export const ACCESS_TOKEN_COOKIE = 'accessToken';

/** Options shared by every auth cookie the app writes (kept apart from authSession to avoid an http-client import cycle). */
export const AUTH_COOKIE_OPTIONS = {
  path: '/',
  sameSite: 'lax',
  secure: window.location.protocol === 'https:'
} as const;

const cookies = new Cookies();

/** Reads the access token cookie, if set. */
export function getAccessTokenCookie(): string | undefined {
  return cookies.get(ACCESS_TOKEN_COOKIE) as string | undefined;
}

/** Stores the access token cookie with the shared auth cookie options. */
export function setAccessTokenCookie(token: string): void {
  cookies.set(ACCESS_TOKEN_COOKIE, token, AUTH_COOKIE_OPTIONS);
}

/** Removes the access token cookie. */
export function removeAccessTokenCookie(): void {
  cookies.remove(ACCESS_TOKEN_COOKIE, { path: AUTH_COOKIE_OPTIONS.path });
}
